import { yellow } from '@mui/material/colors';

export default theme => ({
    root: {
        width: '100%',
        height: 'auto',
        textAlign: 'center'
    },
    headerContainer: {
        textAlign: 'center',
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4)
    },
    headerText: {
        fontSize: '18px',
        fontWeight: 'bolder',
        lineHeight: '1.5'
    },
    section: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: 'block',
        textAlign: 'left'
    },
    underlineOnly: {
        textDecoration: 'underline',
    },
    sectionSpanText: {
        textDecoration: 'underline',
        fontWeight: '500',
        marginRight: theme.spacing(1)
    },
    sectionMainTC: {
        marginTop: theme.spacing(3)
    },
    pointerIndent: {
        paddingLeft: theme.spacing(3),
        textIndent: '-24px'
    },
    sectionIndent: {
        textIndent: '60px'
    },
    sectionBreaker: {
        marginTop: theme.spacing(2)
    },
    italicText: {
        fontStyle: 'italic'
    },
    subsubPoint: {
        marginRight: theme.spacing(1.5)
    },
    addressFlex: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '100%'
    },
    addressRow: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        flexDirection: 'row',
        width: '70%',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    addressRowRight: {
        textAlign: 'left',
        width: '80%',
        fontWeight: '500'
    },
    superBoldOnly: {
        fontWeight: 800
    },
    boldOnly: {
        fontWeight: 500
    },
    redColor: {
        color: '#c62828'
    },
    addressRowLeft: {
        fontWeight: '500'
    },
    marginTop4Px: {
        marginTop: theme.spacing(5),
    },
    areaNames: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        flexDirection: 'column',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        '&>span': {
            fontWeight: '450',
            height: '25px'
        }
    },
    yellowLightBG: {
        background: yellow[300]
    },
    redLightBG: {
        background: '#f4cccc'
    },
    signatureContainer: {
        marginTop: theme.spacing(5)
    },
    signatureBox: {
        border: '1px solid #bdbdbd',
        borderRadius: '6px',
        padding: theme.spacing(2.5),
        maxWidth: '560px',
        backgroundColor: '#fff'
    },
    signatureRow: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1.5),
        '&:last-child': {
            marginBottom: 0
        }
    },
    signatureLabel: {
        minWidth: '180px',
        fontWeight: 500
    },
    signatureValueLine: {
        flex: 1,
        borderBottom: '1px solid #616161',
        minHeight: '24px',
        display: 'flex',
        alignItems: 'flex-end',
        padding: '0 4px 2px'
    }
});
